import { env } from "@/env";

export const isFetchCacheEnabled = () => env.fetchCacheEnable === "1";
